import Swiper from 'swiper/swiper-bundle';
import 'swiper/swiper-bundle.min.css';

function testimonialsSlider() {
	const sliders = document.querySelectorAll('.js-testimonials-slider');
	if (sliders.length > 0) {
		sliders.forEach((slider) => {
			const swiper = new Swiper(slider, {
				direction: 'horizontal',
				slidesPerView: 1,
				loop: true,
				breakpoints: {
					992: {
						direction: 'vertical',
						slidesPerView: 2,
					},
					1200: {
						direction: 'vertical',
						slidesPerView: 2,
					},
					1440: {
						direction: 'vertical',
						slidesPerView: 3,
					},
				},
				on: {
					slideChange: ({ realIndex }) => {
						// Change index on mobile view
						slider.querySelector('.js-testimonials-active-num').innerHTML =
							realIndex + 1;
					},
				},
				navigation: {
					prevEl: slider.querySelector('.js-testimonials-go-prev'),
					nextEl: slider.querySelector('.js-testimonials-go-next'),
				},
			});
			// swiper.slideNext();
		});
	}
}

testimonialsSlider();
